// @ts-nocheck
const getUniqueListByKey = (arr, key) => [...new Map(arr.map(item => [item[key], item])).values()];

export default getUniqueListByKey;
